module.exports = __webpack_public_path__ + "static/Kontakt_Service-c2583d379ccd00b20c8f7b19a500f5cf.jpg";